import { gql } from "@apollo/client";

export const QUERY_IMPORTS = gql`
  query getImports {
    getImports {
      em {
        _id
        dt
        name
        data
      }
      strategy {
        _id
        dt
        name
        data
      }
      encryption {
        _id
        dt
        name
        data
      }
    }
  }
`;

export const QUERY_IMPORT_SUMMARIES = gql`
  query getImportSummaries {
    getImportSummaries {
      type
      summaries {
        _id
        dt
        name
      }
    }
  }
`;

export const QUERY_FULL_IMPORT_FOR_PREVIEW = gql`
  query getImportForPreview($id: String!, $type: String!) {
    getImportForPreview(id: $id, type: $type) {
      type
      data
    }
  }
`;

export const MUTATE_SET_ACTIVE_IMPORT_IDS = gql`
  mutation setActiveImportIDs($activeImportIDs: ActiveImportIDs!) {
    setActiveImportIDs(activeImportIDs: $activeImportIDs)
  }
`;

export const SUBSCRIBE_IMPORTS_UPDATE = gql`
  subscription newImportsUpdate {
    newImportsUpdate {
      em {
        _id
        dt
        name
        data
      }
      strategy {
        _id
        dt
        name
        data
      }
      encryption {
        _id
        dt
        name
        data
      }
    }
  }
`;
